import Message from '../../storybook/Message';
import { useTranslation } from 'react-i18next';
import HeaderJourney from '../../storybook/Header/HeaderJourney';
import { detectMobile } from '../../utils/formatting';

const RepairJourneyErrorPage: React.FC<any> = (props) => {
    const { t } = useTranslation();
    const returnToHome = () => {
        props.history.push('/customer360View');
    };
    const openMobiledialer = () => {
        window.open('tel:' + t('phone_no'));
    };
    const isMobile = detectMobile();
    return (
        <>
            <HeaderJourney></HeaderJourney>
            <div className='padding-repair'>
                {isMobile ? (
                    <Message className='error-msg'>
                        {t(props.location?.state?.message)}
                        <br></br>
                        {t('repair_Journey_Error_Message2')}
                        {
                            <span className='underline'
                                onClick={openMobiledialer}
                                onKeyDown={openMobiledialer}>
                                {t('phone_no')}
                            </span>
                        }
                        <br></br>
                        <br></br>
                        {
                            <span className='underline cursor-pointer'
                                role='link'
                                onKeyDown={returnToHome}
                                onClick={returnToHome} >
                                {t('Return_to_Home')}
                            </span>
                        }
                    </Message>
                ) : (
                    <Message className='error-msg'>
                        {t(props.location?.state?.message)}
                        <br></br>
                        {t('repair_Journey_Error_Message2')}
                        <span>
                            {t('phone_no')}
                        </span>
                        <br></br>
                        <br></br>
                        {
                            <span className='underline cursor-pointer'
                                role='link'
                                onKeyDown={returnToHome}
                                onClick={returnToHome} >
                                {t('Return_to_Home')}
                            </span>
                        }
                    </Message>
                )}
            </div>
        </>
    )
}
export default RepairJourneyErrorPage;